module.exports = __webpack_public_path__ + "static/media/VoboLogo_lightGreen.199462c2.png";